import { createApiClient, CLIENT_HEADER, APP_VERSION_HEADER, BACKGROUND_HEADER } from "@atlas/shared";

export const API_BASE_URL = import.meta.env["VITE_API_URL"] ?? "/api";

/**
 * Presence headers (spec 14 usage analytics). A hidden tab is "background":
 * React Query refetches from it must not count as the user being in the app.
 */
export function clientHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    [CLIENT_HEADER]: "web",
    [APP_VERSION_HEADER]: __ATLAS_BUILD_ID__,
  };
  if (typeof document !== "undefined" && document.visibilityState === "hidden") {
    headers[BACKGROUND_HEADER] = "1";
  }
  return headers;
}

const _client = createApiClient({
  baseUrl: API_BASE_URL,
  credentials: "include",
  getClientHeaders: clientHeaders,
});

// For @atlas/shared fetchers that take the client as their first argument
// (api/social.ts, api/landmarks.ts, …).
export const apiClient = _client;

export const apiGet = <T>(path: string): Promise<T> => _client.get<T>(path);
export const apiPost = <T>(path: string, body?: unknown): Promise<T> => _client.post<T>(path, body);
export const apiPatch = <T>(path: string, body?: unknown): Promise<T> => _client.patch<T>(path, body);
export const apiDelete = <T>(path: string, body?: unknown): Promise<T> => _client.delete<T>(path, body);
